import React, { useContext } from "react";
import IAccounting from "../../../../models/IAccounting";
import OwButton from "../../../shared/OwButton/OwButton";
import UiContext from "../../../../contexts/UiContext";

type Props = {
    row: IAccounting;
    downloadJson: (row: IAccounting) => void;
};

export const AccountingActionsCol = (props: Props) => {
    const uiContext = useContext(UiContext);

    return (
        <span className={"AccountingActionsCol"}>
            {uiContext.showHiddenFeatures ? (
                <OwButton
                    fn={() => {
                        props.downloadJson(props.row);
                    }}
                    title={"download_json"}
                    className={"btn-primary ms-2"}
                />
            ) : null}
        </span>
    );
};
